/**
 * Reports a new account to Google Ads as the secondary conversion
 * "InMyResume – Sign up" (reportAdsStep in composables/useAdsConversion.ts).
 *
 * Watched here rather than in the sign-up forms because an account is born in
 * several places: the e-mail form, the quick sign-up under a CV, and Google
 * sign-in, which leaves the page and comes back through /auth/callback. The
 * user shows up in all of them, so a user created in the last day counts once
 * per browser, and Ads drops a repeat by its transaction id
 * (`signup-<user id>`) if the same account signs in on a second device.
 *
 * Off when NUXT_PUBLIC_ADS_SIGNUP_SEND_TO is set empty (nuxt.config.ts).
 */
const NEW_ACCOUNT_MS = 24 * 60 * 60 * 1000

export default defineNuxtPlugin(() => {
  const sendTo = useRuntimeConfig().public.adsSignupSendTo
  if (!sendTo) return

  const user = useSupabaseUser()
  watch(user, (u) => {
    const created = u?.created_at ? Date.parse(u.created_at) : Number.NaN
    // An anonymous session is not an account.
    if (!u?.id || u.is_anonymous || !(Date.now() - created < NEW_ACCOUNT_MS)) return
    reportAdsStep(sendTo, `signup-${u.id}`)
  }, { immediate: true })
})
